module.exports = __webpack_public_path__ + "static/media/selfcare.b408a250.jpg";